// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IClaimParticipantResponseDto,
  IClaimParticipantSearchDto,
  IContributionActivityRecordResponseDto,
  ICoveragePeriodDto,
  ICustomPageFileSearchInfoDto,
  IEmployeePlanCodeDto,
  IErrorDto,
  IGenericErrorDto,
  IPageEmployeeContributionDto,
  IPageEmployeeScheduledContributionDto,
  IPageFundsHistoryItemDto,
  IPageSearchEmployeeInfoDto,
  IPageUnappliedFundsByOrganizationDto,
  IScheduledCalendarDto,
  IScheduledContributionSummaryDto,
  IUnmatchedPushTotalBalanceDto,
} from '../models/index';
import {
    IClaimParticipantResponseDtoFromJSON,
    IClaimParticipantResponseDtoToJSON,
    IClaimParticipantSearchDtoFromJSON,
    IClaimParticipantSearchDtoToJSON,
    IContributionActivityRecordResponseDtoFromJSON,
    IContributionActivityRecordResponseDtoToJSON,
    ICoveragePeriodDtoFromJSON,
    ICoveragePeriodDtoToJSON,
    ICustomPageFileSearchInfoDtoFromJSON,
    ICustomPageFileSearchInfoDtoToJSON,
    IEmployeePlanCodeDtoFromJSON,
    IEmployeePlanCodeDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    IPageEmployeeContributionDtoFromJSON,
    IPageEmployeeContributionDtoToJSON,
    IPageEmployeeScheduledContributionDtoFromJSON,
    IPageEmployeeScheduledContributionDtoToJSON,
    IPageFundsHistoryItemDtoFromJSON,
    IPageFundsHistoryItemDtoToJSON,
    IPageSearchEmployeeInfoDtoFromJSON,
    IPageSearchEmployeeInfoDtoToJSON,
    IPageUnappliedFundsByOrganizationDtoFromJSON,
    IPageUnappliedFundsByOrganizationDtoToJSON,
    IScheduledCalendarDtoFromJSON,
    IScheduledCalendarDtoToJSON,
    IScheduledContributionSummaryDtoFromJSON,
    IScheduledContributionSummaryDtoToJSON,
    IUnmatchedPushTotalBalanceDtoFromJSON,
    IUnmatchedPushTotalBalanceDtoToJSON,
} from '../models/index';

export interface GetCoveragePeriodsRequest {
    iEmployeePlanCodeDto: Array<IEmployeePlanCodeDto>;
}

export interface GetEmployeeScheduledContributionCsvReportRequest {
    calendarId: number;
    startDate: Date;
    taxType?: string;
    planCodes?: Array<string>;
    name?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetEmployeesWithActivePlanRequest {
    searchValue?: string;
}

export interface GetFilesRequest {
    searchValue?: string;
    uploadedBy?: number;
    fileType?: Array<GetFilesFileTypeEnum>;
    fileProcessingStatusType?: Array<GetFilesFileProcessingStatusTypeEnum>;
    createdDateFrom?: Date;
    createdDateTo?: Date;
    duplicateFileId?: number;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetManualContributionEmployeesCountRequest {
    planIds?: Array<number>;
    organizationIds?: Array<number>;
    employeeIds?: Array<number>;
    firstName?: string;
    lastName?: string;
    templateContributionId?: number;
    payrollGroupCodes?: Set<string>;
    contributionDate?: Date;
}

export interface SearchEngineFindScheduledContributionsForOrganizationRequest {
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SearchFundsHistoryRequest {
    organizationId?: number;
    search?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SearchManualContributionEmployeesRequest {
    planIds?: Array<number>;
    organizationIds?: Array<number>;
    employeeIds?: Array<number>;
    firstName?: string;
    lastName?: string;
    templateContributionId?: number;
    payrollGroupCodes?: Set<string>;
    contributionDate?: Date;
}

export interface SearchParticipantClaimsRequest {
    iClaimParticipantSearchDto: IClaimParticipantSearchDto;
}

export interface SearchScheduledContributionEmployeesRequest {
    calendarId: number;
    startDate: Date;
    planCodes?: Array<string>;
    name?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface SearchScheduledContributionSummaryRequest {
    calendarId: number;
    startDate: Date;
    planCodes?: Array<string>;
    name?: string;
}

export interface SearchUnappliedFundsByOrganizationRequest {
    search?: string;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

/**
 * SearchEngineServiceServiceApi - interface
 * 
 * @export
 * @interface SearchEngineServiceServiceApiInterface
 */
export interface SearchEngineServiceServiceApiInterface {
    /**
     * 
     * @summary Get coverage period by employee ids and plan codes
     * @param {Array<IEmployeePlanCodeDto>} iEmployeePlanCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    getCoveragePeriodsRaw(requestParameters: GetCoveragePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICoveragePeriodDto>>>;

    /**
     * Get coverage period by employee ids and plan codes
     */
    getCoveragePeriods(requestParameters: GetCoveragePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICoveragePeriodDto>>;

    /**
     * 
     * @summary Employee scheduled contribution csv report
     * @param {number} calendarId 
     * @param {Date} startDate 
     * @param {string} [taxType] 
     * @param {Array<string>} [planCodes] 
     * @param {string} [name] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    getEmployeeScheduledContributionCsvReportRaw(requestParameters: GetEmployeeScheduledContributionCsvReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionActivityRecordResponseDto>>;

    /**
     * Employee scheduled contribution csv report
     */
    getEmployeeScheduledContributionCsvReport(requestParameters: GetEmployeeScheduledContributionCsvReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionActivityRecordResponseDto>;

    /**
     * 
     * @param {string} [searchValue] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    getEmployeesWithActivePlanRaw(requestParameters: GetEmployeesWithActivePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageSearchEmployeeInfoDto>>;

    /**
     */
    getEmployeesWithActivePlan(requestParameters: GetEmployeesWithActivePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageSearchEmployeeInfoDto>;

    /**
     * 
     * @param {string} [searchValue] 
     * @param {number} [uploadedBy] 
     * @param {Array<'CENSUS' | 'ENROLLMENT' | 'CONTRIBUTION' | 'MD' | 'ED' | 'BAI2' | 'BR' | 'MIXED' | 'CIP' | 'ISO_302' | 'UNKNOWN' | 'PGP_BAI2' | 'CARRIER' | 'ACH' | 'CHECK_PAID' | 'CHECK_CANCELLED' | 'DEPENDENT' | 'BALANCE_ADJUSTMENT'>} [fileType] 
     * @param {Array<'INITIATED' | 'UPLOADED' | 'PARSED' | 'VALIDATED' | 'APPROVED' | 'PROCESSING' | 'COMPLETED' | 'QUALITY_GATES_FAILED' | 'ERROR' | 'DUPLICATE' | 'CANCELLED'>} [fileProcessingStatusType] 
     * @param {Date} [createdDateFrom] 
     * @param {Date} [createdDateTo] 
     * @param {number} [duplicateFileId] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    getFilesRaw(requestParameters: GetFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageFileSearchInfoDto>>;

    /**
     */
    getFiles(requestParameters: GetFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageFileSearchInfoDto>;

    /**
     * 
     * @param {Array<number>} [planIds] 
     * @param {Array<number>} [organizationIds] 
     * @param {Array<number>} [employeeIds] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {number} [templateContributionId] 
     * @param {Set<string>} [payrollGroupCodes] 
     * @param {Date} [contributionDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    getManualContributionEmployeesCountRaw(requestParameters: GetManualContributionEmployeesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>>;

    /**
     */
    getManualContributionEmployeesCount(requestParameters: GetManualContributionEmployeesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number>;

    /**
     * Aggregates, in a single query, the unapplied push clearing balances (accounts with a positive available balance) across every organization under the current admin\'s hierarchy. Returns the total balance, the first 20 matched organization names (sorted by name) and the total number of matched organizations as a separate field.
     * @summary Aggregate unapplied push total balance for the current organization hierarchy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    getTotalBalanceGetUnmatchedPushTransactionsTotalBalanceAggregatedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IUnmatchedPushTotalBalanceDto>>;

    /**
     * Aggregates, in a single query, the unapplied push clearing balances (accounts with a positive available balance) across every organization under the current admin\'s hierarchy. Returns the total balance, the first 20 matched organization names (sorted by name) and the total number of matched organizations as a separate field.
     * Aggregate unapplied push total balance for the current organization hierarchy
     */
    getTotalBalanceGetUnmatchedPushTransactionsTotalBalanceAggregated(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IUnmatchedPushTotalBalanceDto>;

    /**
     * 
     * @summary Find list of scheduled contributions for the organization
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    searchEngineFindScheduledContributionsForOrganizationRaw(requestParameters: SearchEngineFindScheduledContributionsForOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledCalendarDto>>;

    /**
     * Find list of scheduled contributions for the organization
     */
    searchEngineFindScheduledContributionsForOrganization(requestParameters: SearchEngineFindScheduledContributionsForOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledCalendarDto>;

    /**
     * Returns a union of incoming push transactions (received, unmatched) and paid push invoices (applied) for the organization resolved from the security context, newest first. Applied rows show a negative amount (invoice.amount) and an \'Applied to invoice [id]\' description, dated by invoice.ended_at; received rows show a positive amount and a \'Funds received [account number]\' description, dated by the transaction created_at. Optional organization_id narrows to a single organization. Optional search matches amount, invoice id, or the full account number (the account number is encrypted at rest, so the search value is encrypted before matching).
     * @summary Search funds history for the current organization
     * @param {number} [organizationId] 
     * @param {string} [search] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    searchFundsHistoryRaw(requestParameters: SearchFundsHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageFundsHistoryItemDto>>;

    /**
     * Returns a union of incoming push transactions (received, unmatched) and paid push invoices (applied) for the organization resolved from the security context, newest first. Applied rows show a negative amount (invoice.amount) and an \'Applied to invoice [id]\' description, dated by invoice.ended_at; received rows show a positive amount and a \'Funds received [account number]\' description, dated by the transaction created_at. Optional organization_id narrows to a single organization. Optional search matches amount, invoice id, or the full account number (the account number is encrypted at rest, so the search value is encrypted before matching).
     * Search funds history for the current organization
     */
    searchFundsHistory(requestParameters: SearchFundsHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageFundsHistoryItemDto>;

    /**
     * 
     * @param {Array<number>} [planIds] 
     * @param {Array<number>} [organizationIds] 
     * @param {Array<number>} [employeeIds] 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {number} [templateContributionId] 
     * @param {Set<string>} [payrollGroupCodes] 
     * @param {Date} [contributionDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    searchManualContributionEmployeesRaw(requestParameters: SearchManualContributionEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageEmployeeContributionDto>>;

    /**
     */
    searchManualContributionEmployees(requestParameters: SearchManualContributionEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageEmployeeContributionDto>;

    /**
     * 
     * @param {IClaimParticipantSearchDto} iClaimParticipantSearchDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    searchParticipantClaimsRaw(requestParameters: SearchParticipantClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimParticipantResponseDto>>;

    /**
     */
    searchParticipantClaims(requestParameters: SearchParticipantClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimParticipantResponseDto>;

    /**
     * 
     * @param {number} calendarId 
     * @param {Date} startDate 
     * @param {Array<string>} [planCodes] 
     * @param {string} [name] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    searchScheduledContributionEmployeesRaw(requestParameters: SearchScheduledContributionEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageEmployeeScheduledContributionDto>>;

    /**
     */
    searchScheduledContributionEmployees(requestParameters: SearchScheduledContributionEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageEmployeeScheduledContributionDto>;

    /**
     * 
     * @param {number} calendarId 
     * @param {Date} startDate 
     * @param {Array<string>} [planCodes] 
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    searchScheduledContributionSummaryRaw(requestParameters: SearchScheduledContributionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledContributionSummaryDto>>;

    /**
     */
    searchScheduledContributionSummary(requestParameters: SearchScheduledContributionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledContributionSummaryDto>;

    /**
     * Returns unapplied push funds (unapplied_push_clearing_account balances with a positive available balance) grouped by organization for the current admin\'s hierarchy, enriched with the organization\'s unpaid push-invoice totals (amount and count). For a subsidiary, organizationName is the parent (employer) name and subsidiaryName is the subsidiary\'s own name. Sorted by organization name ascending. Optional search matches organization name or amount (unapplied funds or unpaid invoices sum).
     * @summary Search unapplied push funds grouped by organization
     * @param {string} [search] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchEngineServiceServiceApiInterface
     */
    searchUnappliedFundsByOrganizationRaw(requestParameters: SearchUnappliedFundsByOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageUnappliedFundsByOrganizationDto>>;

    /**
     * Returns unapplied push funds (unapplied_push_clearing_account balances with a positive available balance) grouped by organization for the current admin\'s hierarchy, enriched with the organization\'s unpaid push-invoice totals (amount and count). For a subsidiary, organizationName is the parent (employer) name and subsidiaryName is the subsidiary\'s own name. Sorted by organization name ascending. Optional search matches organization name or amount (unapplied funds or unpaid invoices sum).
     * Search unapplied push funds grouped by organization
     */
    searchUnappliedFundsByOrganization(requestParameters: SearchUnappliedFundsByOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageUnappliedFundsByOrganizationDto>;

}

/**
 * 
 */
export class SearchEngineServiceServiceApi extends runtime.BaseAPI implements SearchEngineServiceServiceApiInterface {

    /**
     * Get coverage period by employee ids and plan codes
     */
    async getCoveragePeriodsRaw(requestParameters: GetCoveragePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICoveragePeriodDto>>> {
        if (requestParameters['iEmployeePlanCodeDto'] == null) {
            throw new runtime.RequiredError(
                'iEmployeePlanCodeDto',
                'Required parameter "iEmployeePlanCodeDto" was null or undefined when calling getCoveragePeriods().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/manual-contribution/coverage-periods`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['iEmployeePlanCodeDto']!.map(IEmployeePlanCodeDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICoveragePeriodDtoFromJSON));
    }

    /**
     * Get coverage period by employee ids and plan codes
     */
    async getCoveragePeriods(requestParameters: GetCoveragePeriodsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICoveragePeriodDto>> {
        const response = await this.getCoveragePeriodsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Employee scheduled contribution csv report
     */
    async getEmployeeScheduledContributionCsvReportRaw(requestParameters: GetEmployeeScheduledContributionCsvReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IContributionActivityRecordResponseDto>> {
        if (requestParameters['calendarId'] == null) {
            throw new runtime.RequiredError(
                'calendarId',
                'Required parameter "calendarId" was null or undefined when calling getEmployeeScheduledContributionCsvReport().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getEmployeeScheduledContributionCsvReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['taxType'] != null) {
            queryParameters['tax_type'] = requestParameters['taxType'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['planCodes'] != null) {
            queryParameters['plan_codes'] = requestParameters['planCodes'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scheduled-contribution-search/calendar/{calendar_id}/csv-report`;
        urlPath = urlPath.replace(`{${"calendar_id"}}`, encodeURIComponent(String(requestParameters['calendarId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IContributionActivityRecordResponseDtoFromJSON(jsonValue));
    }

    /**
     * Employee scheduled contribution csv report
     */
    async getEmployeeScheduledContributionCsvReport(requestParameters: GetEmployeeScheduledContributionCsvReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IContributionActivityRecordResponseDto> {
        const response = await this.getEmployeeScheduledContributionCsvReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmployeesWithActivePlanRaw(requestParameters: GetEmployeesWithActivePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageSearchEmployeeInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/employee-search/active-plan`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageSearchEmployeeInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getEmployeesWithActivePlan(requestParameters: GetEmployeesWithActivePlanRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageSearchEmployeeInfoDto> {
        const response = await this.getEmployeesWithActivePlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFilesRaw(requestParameters: GetFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICustomPageFileSearchInfoDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchValue'] != null) {
            queryParameters['search_value'] = requestParameters['searchValue'];
        }

        if (requestParameters['uploadedBy'] != null) {
            queryParameters['uploaded_by'] = requestParameters['uploadedBy'];
        }

        if (requestParameters['fileType'] != null) {
            queryParameters['file_type'] = requestParameters['fileType'];
        }

        if (requestParameters['fileProcessingStatusType'] != null) {
            queryParameters['file_processing_status_type'] = requestParameters['fileProcessingStatusType'];
        }

        if (requestParameters['createdDateFrom'] != null) {
            queryParameters['created_date_from'] = (requestParameters['createdDateFrom'] as any).toISOString();
        }

        if (requestParameters['createdDateTo'] != null) {
            queryParameters['created_date_to'] = (requestParameters['createdDateTo'] as any).toISOString();
        }

        if (requestParameters['duplicateFileId'] != null) {
            queryParameters['duplicate_file_id'] = requestParameters['duplicateFileId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/files-search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICustomPageFileSearchInfoDtoFromJSON(jsonValue));
    }

    /**
     */
    async getFiles(requestParameters: GetFilesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICustomPageFileSearchInfoDto> {
        const response = await this.getFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getManualContributionEmployeesCountRaw(requestParameters: GetManualContributionEmployeesCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['organizationIds'] != null) {
            queryParameters['organization_ids'] = requestParameters['organizationIds'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['templateContributionId'] != null) {
            queryParameters['template_contribution_id'] = requestParameters['templateContributionId'];
        }

        if (requestParameters['payrollGroupCodes'] != null) {
            queryParameters['payroll_group_codes'] = requestParameters['payrollGroupCodes'];
        }

        if (requestParameters['contributionDate'] != null) {
            queryParameters['contribution_date'] = (requestParameters['contributionDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/manual-contribution/employees/count`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<number>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getManualContributionEmployeesCount(requestParameters: GetManualContributionEmployeesCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getManualContributionEmployeesCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aggregates, in a single query, the unapplied push clearing balances (accounts with a positive available balance) across every organization under the current admin\'s hierarchy. Returns the total balance, the first 20 matched organization names (sorted by name) and the total number of matched organizations as a separate field.
     * Aggregate unapplied push total balance for the current organization hierarchy
     */
    async getTotalBalanceGetUnmatchedPushTransactionsTotalBalanceAggregatedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IUnmatchedPushTotalBalanceDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/unmatched-push-transactions/total-balance/aggregated`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IUnmatchedPushTotalBalanceDtoFromJSON(jsonValue));
    }

    /**
     * Aggregates, in a single query, the unapplied push clearing balances (accounts with a positive available balance) across every organization under the current admin\'s hierarchy. Returns the total balance, the first 20 matched organization names (sorted by name) and the total number of matched organizations as a separate field.
     * Aggregate unapplied push total balance for the current organization hierarchy
     */
    async getTotalBalanceGetUnmatchedPushTransactionsTotalBalanceAggregated(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IUnmatchedPushTotalBalanceDto> {
        const response = await this.getTotalBalanceGetUnmatchedPushTransactionsTotalBalanceAggregatedRaw(initOverrides);
        return await response.value();
    }

    /**
     * Find list of scheduled contributions for the organization
     */
    async searchEngineFindScheduledContributionsForOrganizationRaw(requestParameters: SearchEngineFindScheduledContributionsForOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledCalendarDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scheduled-contribution-search/organization`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IScheduledCalendarDtoFromJSON(jsonValue));
    }

    /**
     * Find list of scheduled contributions for the organization
     */
    async searchEngineFindScheduledContributionsForOrganization(requestParameters: SearchEngineFindScheduledContributionsForOrganizationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledCalendarDto> {
        const response = await this.searchEngineFindScheduledContributionsForOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a union of incoming push transactions (received, unmatched) and paid push invoices (applied) for the organization resolved from the security context, newest first. Applied rows show a negative amount (invoice.amount) and an \'Applied to invoice [id]\' description, dated by invoice.ended_at; received rows show a positive amount and a \'Funds received [account number]\' description, dated by the transaction created_at. Optional organization_id narrows to a single organization. Optional search matches amount, invoice id, or the full account number (the account number is encrypted at rest, so the search value is encrypted before matching).
     * Search funds history for the current organization
     */
    async searchFundsHistoryRaw(requestParameters: SearchFundsHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageFundsHistoryItemDto>> {
        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/unmatched-push-transactions/funds-history-search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageFundsHistoryItemDtoFromJSON(jsonValue));
    }

    /**
     * Returns a union of incoming push transactions (received, unmatched) and paid push invoices (applied) for the organization resolved from the security context, newest first. Applied rows show a negative amount (invoice.amount) and an \'Applied to invoice [id]\' description, dated by invoice.ended_at; received rows show a positive amount and a \'Funds received [account number]\' description, dated by the transaction created_at. Optional organization_id narrows to a single organization. Optional search matches amount, invoice id, or the full account number (the account number is encrypted at rest, so the search value is encrypted before matching).
     * Search funds history for the current organization
     */
    async searchFundsHistory(requestParameters: SearchFundsHistoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageFundsHistoryItemDto> {
        const response = await this.searchFundsHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchManualContributionEmployeesRaw(requestParameters: SearchManualContributionEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageEmployeeContributionDto>> {
        const queryParameters: any = {};

        if (requestParameters['planIds'] != null) {
            queryParameters['plan_ids'] = requestParameters['planIds'];
        }

        if (requestParameters['organizationIds'] != null) {
            queryParameters['organization_ids'] = requestParameters['organizationIds'];
        }

        if (requestParameters['employeeIds'] != null) {
            queryParameters['employee_ids'] = requestParameters['employeeIds'];
        }

        if (requestParameters['firstName'] != null) {
            queryParameters['first_name'] = requestParameters['firstName'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['templateContributionId'] != null) {
            queryParameters['template_contribution_id'] = requestParameters['templateContributionId'];
        }

        if (requestParameters['payrollGroupCodes'] != null) {
            queryParameters['payroll_group_codes'] = requestParameters['payrollGroupCodes'];
        }

        if (requestParameters['contributionDate'] != null) {
            queryParameters['contribution_date'] = (requestParameters['contributionDate'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/manual-contribution/employees`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageEmployeeContributionDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchManualContributionEmployees(requestParameters: SearchManualContributionEmployeesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageEmployeeContributionDto> {
        const response = await this.searchManualContributionEmployeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchParticipantClaimsRaw(requestParameters: SearchParticipantClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IClaimParticipantResponseDto>> {
        if (requestParameters['iClaimParticipantSearchDto'] == null) {
            throw new runtime.RequiredError(
                'iClaimParticipantSearchDto',
                'Required parameter "iClaimParticipantSearchDto" was null or undefined when calling searchParticipantClaims().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/claims/search/participant`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IClaimParticipantSearchDtoToJSON(requestParameters['iClaimParticipantSearchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IClaimParticipantResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchParticipantClaims(requestParameters: SearchParticipantClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IClaimParticipantResponseDto> {
        const response = await this.searchParticipantClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchScheduledContributionEmployeesRaw(requestParameters: SearchScheduledContributionEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageEmployeeScheduledContributionDto>> {
        if (requestParameters['calendarId'] == null) {
            throw new runtime.RequiredError(
                'calendarId',
                'Required parameter "calendarId" was null or undefined when calling searchScheduledContributionEmployees().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling searchScheduledContributionEmployees().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['planCodes'] != null) {
            queryParameters['plan_codes'] = requestParameters['planCodes'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scheduled-contribution-search/calendar/{calendar_id}/employees`;
        urlPath = urlPath.replace(`{${"calendar_id"}}`, encodeURIComponent(String(requestParameters['calendarId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageEmployeeScheduledContributionDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchScheduledContributionEmployees(requestParameters: SearchScheduledContributionEmployeesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageEmployeeScheduledContributionDto> {
        const response = await this.searchScheduledContributionEmployeesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchScheduledContributionSummaryRaw(requestParameters: SearchScheduledContributionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IScheduledContributionSummaryDto>> {
        if (requestParameters['calendarId'] == null) {
            throw new runtime.RequiredError(
                'calendarId',
                'Required parameter "calendarId" was null or undefined when calling searchScheduledContributionSummary().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling searchScheduledContributionSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['planCodes'] != null) {
            queryParameters['plan_codes'] = requestParameters['planCodes'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/scheduled-contribution-search/calendar/{calendar_id}/summary`;
        urlPath = urlPath.replace(`{${"calendar_id"}}`, encodeURIComponent(String(requestParameters['calendarId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IScheduledContributionSummaryDtoFromJSON(jsonValue));
    }

    /**
     */
    async searchScheduledContributionSummary(requestParameters: SearchScheduledContributionSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IScheduledContributionSummaryDto> {
        const response = await this.searchScheduledContributionSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns unapplied push funds (unapplied_push_clearing_account balances with a positive available balance) grouped by organization for the current admin\'s hierarchy, enriched with the organization\'s unpaid push-invoice totals (amount and count). For a subsidiary, organizationName is the parent (employer) name and subsidiaryName is the subsidiary\'s own name. Sorted by organization name ascending. Optional search matches organization name or amount (unapplied funds or unpaid invoices sum).
     * Search unapplied push funds grouped by organization
     */
    async searchUnappliedFundsByOrganizationRaw(requestParameters: SearchUnappliedFundsByOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageUnappliedFundsByOrganizationDto>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/unmatched-push-transactions/by-organization`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageUnappliedFundsByOrganizationDtoFromJSON(jsonValue));
    }

    /**
     * Returns unapplied push funds (unapplied_push_clearing_account balances with a positive available balance) grouped by organization for the current admin\'s hierarchy, enriched with the organization\'s unpaid push-invoice totals (amount and count). For a subsidiary, organizationName is the parent (employer) name and subsidiaryName is the subsidiary\'s own name. Sorted by organization name ascending. Optional search matches organization name or amount (unapplied funds or unpaid invoices sum).
     * Search unapplied push funds grouped by organization
     */
    async searchUnappliedFundsByOrganization(requestParameters: SearchUnappliedFundsByOrganizationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageUnappliedFundsByOrganizationDto> {
        const response = await this.searchUnappliedFundsByOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetFilesFileTypeEnum {
    CENSUS = 'CENSUS',
    ENROLLMENT = 'ENROLLMENT',
    CONTRIBUTION = 'CONTRIBUTION',
    MD = 'MD',
    ED = 'ED',
    BAI2 = 'BAI2',
    BR = 'BR',
    MIXED = 'MIXED',
    CIP = 'CIP',
    ISO_302 = 'ISO_302',
    UNKNOWN = 'UNKNOWN',
    PGP_BAI2 = 'PGP_BAI2',
    CARRIER = 'CARRIER',
    ACH = 'ACH',
    CHECK_PAID = 'CHECK_PAID',
    CHECK_CANCELLED = 'CHECK_CANCELLED',
    DEPENDENT = 'DEPENDENT',
    BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT'
}
/**
  * @export
  * @enum {string}
  */
export enum GetFilesFileProcessingStatusTypeEnum {
    INITIATED = 'INITIATED',
    UPLOADED = 'UPLOADED',
    PARSED = 'PARSED',
    VALIDATED = 'VALIDATED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    QUALITY_GATES_FAILED = 'QUALITY_GATES_FAILED',
    ERROR = 'ERROR',
    DUPLICATE = 'DUPLICATE',
    CANCELLED = 'CANCELLED'
}
